import React, { Component } from 'react';
import {Spinner} from 'react-bootstrap';

export default function ProgressIndicator() {
    return <Spinner animation="grow" />;
}
